// Thin wrapper around AntD Button. Reasons it exists:
//   - centralises the import surface so a future swap (e.g. our own button)
//     touches one file instead of every feature.
//   - lets us layer on industry-aware behaviour (size defaults, copy from
//     useCopy, etc.) without bloating callers.
//
// Otherwise behaves identically to AntD's Button.
import { Button as AntButton } from 'antd';

export default function Button(props) {
  return <AntButton {...props} />;
}
